export default __webpack_public_path__ + "static/media/ISKO CLASS-6 EXAM PATTERN 2025.70e31cc7.pdf";